import { createIcon } from '../icon'
import EmailIcon from '../svg/EmailIcon'

export const EmailIconDefault = createIcon(EmailIcon)
